import { render, staticRenderFns } from "./LotCard.vue?vue&type=template&id=3d889187&scoped=true"
import script from "./LotCard.vue?vue&type=script&lang=js"
export * from "./LotCard.vue?vue&type=script&lang=js"
import style0 from "./LotCard.vue?vue&type=style&index=0&id=3d889187&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d889187",
  null
  
)

export default component.exports